<template>
  <div class="m-2 flex-grow-1">
    <button
      :class="[
        cssClass !== null ? cssClass : { 'style-button-color': color === null },
        'style-button rounded border-0',
      ]"
      :style="`background-color:${color}`"
      :type="type"
      :disabled="disabled"
    >
      <template v-if="buttonChecked">
        <i class="bi bi-check2 icon-style"></i>
      </template>
      <template v-else>{{ title }}</template>
    </button>
  </div>
</template>

<script>
export default {
  name: "DefaultButton",
  props: {
    title: String,
    color: {
      type: String,
      default: null,
    },
    cssClass: {
      type: String,
      default: null,
    },
    type: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonChecked: {
      type: Boolean,
      default: false,
    },
    style: Object,
  },
};
</script>

<style lang="scss" scoped>
.style-button {
  color: $white-color;
  height: 48px;
  width: 100%;
  transition: 0.3s;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}

.style-button-color {
  background-color: $text-blue;
}

.style-button:hover:enabled {
  opacity: 0.8;
}

.style-button:active:enabled {
  box-shadow: 3px 2px 22px 1px rgba(134, 134, 134, 0.24);
  transform: scale(1.02, 1.02);
}

.icon-style {
  font-size: 30px;
}

button:disabled,
button[disabled] {
  opacity: 0.7;
}
</style>
